import { useState, useEffect } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import GraficoVenda from "../components/Graficos/GraficoVenda";



function Adm() {
  const [usersList, setUsersList] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [vendaList, setVendaList] = useState([]);
  const [rangeDateSells, setRangeDateSells] = useState(60); // Estado inicial com 60 dias

  // Função para buscar usuários
  async function getUsers() {
    try {
      const response = await api.get('/servicos'); // Faz a requisição para a API
      const resUsers = await api.get('/usuariosCadastrados');
      setUsersList(resUsers.data);
      setServicos(response.data); // Atualiza o estado com os serviços
    } catch (error) {
      NotificationManager.error('Erro ao buscar usuários', 'Erro', 3000);
    }
  }

  async function getFinancas(maxDias) {
    try {
      const responseVendaList = await api.get(`/FinancasAgiliza?maxDias=${maxDias}`);
      console.log("financas");
      setVendaList(responseVendaList.data);
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }



useEffect(() => {
  getUsers();
  carregarFontes();
}, []);

useEffect(() => {
  console.log("cpf");
  getFinancas(rangeDateSells);
}, [rangeDateSells]);


  const [listaFontes, setListaFontes] = useState([]);
  const [nomeFonte, setNomeFonte] = useState("");
  const [valorFonte, setValorFonte] = useState("");
  const [fonteEditando, setFonteEditando] = useState(null);


  async function carregarFontes() {
    const response = await api.get("/fonteLeads");
    setListaFontes(response.data);
  }

  async function salvarFonte() {
    if (fonteEditando) {
      await api.post("/fonteLeads/update", { id: fonteEditando.id, nome: nomeFonte, value: valorFonte });
    } else {
      await api.post("/fonteLeads/create", { nome: nomeFonte, value: valorFonte });
    }
    setNomeFonte(""); setValorFonte(""); setFonteEditando(null);
    carregarFontes();
  }

  function editarFonte(fonte) {
    setFonteEditando(fonte);
    setNomeFonte(fonte.nome);
    setValorFonte(fonte.value);
  }

  async function deletarFonte(id) {
    await api.post("/fonteLeads/delete", { id });
    carregarFontes();
  }


  const [nomeServico, setNomeServico] = useState("");
  const [valorServico, setValorServico] = useState("");
  const [servicoEditando, setServicoEditando] = useState(null);


  async function salvarServico() {
    if (!nomeServico || !valorServico) return;

    const payload = {
      nome: nomeServico,
      value: parseFloat(valorServico),
    };

    if (servicoEditando) {
      await api.post("/servicos/update", { ...payload, id: servicoEditando.id });
    } else {
      await api.post("/servicos/create", payload);
    }

    setNomeServico("");
    setValorServico("");
    setServicoEditando(null);
    getUsers(); // recarrega a lista
  }

  function editarServico(servico) {
    setServicoEditando(servico);
    setNomeServico(servico.nome);
    setValorServico(servico.value);
  }

  async function deletarServico(id) {
    if (window.confirm("Tem certeza que deseja excluir este serviço?")) {
      await api.post("/servicos/delete", { id });
      getUsers();
    }
  }




  return (
    <div className={styles.app}>
      <NotificationContainer />



      <div className={styles.cadastroClienteContainer}>
        <div className={styles.usersListContainer}>
          <h1>Fontes de Leads</h1>

          {/* Formulário de nova fonte */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
            <input type="text" placeholder="Nome" value={nomeFonte} onChange={(e) => setNomeFonte(e.target.value)} />
            {/* <input type="number" placeholder="Valor" value={valorFonte} onChange={(e) => setValorFonte(e.target.value)} /> */}
            <>
              <button onClick={salvarFonte}>
                {fonteEditando ? "Atualizar" : "Acrescentar"}
              </button>
              {fonteEditando && (
                <button
                  style={{ backgroundColor: "#ccc", color: "#000" }}
                  onClick={() => {
                    setFonteEditando(null);
                    setNomeFonte("");
                    setValorFonte("");
                  }}
                >
                  Cancelar edição
                </button>
              )}
            </>

          </div>

          {/* Tabela de fontes existentes */}
          <table className={styles.usersTable}>
            <thead>
              <tr>
                {/* <th>ID</th> */}
                <th>Nome</th>
                {/* <th>Valor</th> */}
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {listaFontes.map(fonte => (
                <tr key={fonte.id}>
                  {/* <td>{fonte.id}</td> */}
                  <td>{fonte.nome}</td>
                  {/* <td>{fonte.value}</td> */}
                  <td>
                    {fonte.id <= 1 ? (
                      <span style={{ color: 'gray' }}>Bloqueado</span>
                    ) : (
                      <>
                        <button onClick={() => editarFonte(fonte)}>Editar</button>
                        <button onClick={() => deletarFonte(fonte.id)}>Excluir</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>



      <div className={styles.cadastroClienteContainer}>
        <div className={styles.usersListContainer}>
          <h1>Serviços cadastrados</h1>

          {/* Formulário de novo serviço */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
            <input type="text" placeholder="Nome do serviço" value={nomeServico} onChange={(e) => setNomeServico(e.target.value)} />
            <input type="number" placeholder="Valor (R$)" value={valorServico} onChange={(e) => setValorServico(e.target.value)} />
            <button onClick={salvarServico}>{servicoEditando ? "Atualizar" : "Acrescentar"}</button>
            {servicoEditando && (
              <button
                style={{ backgroundColor: "#ccc", color: "#000" }}
                onClick={() => {
                  setServicoEditando(null);
                  setNomeServico("");
                  setValorServico("");
                }}
              >
                Cancelar edição
              </button>
            )}
          </div>

          {/* Lista de serviços */}
          <table className={styles.usersTable} style={{ width: '90%' }}>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Valor (R$)</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {servicos.map((item) => (
                <tr key={item.id}>
                  <td>{item.nome}</td>
                  <td>{item.value}</td>
                  <td>
                    <button onClick={() => editarServico(item)}>Editar</button>
                    <button onClick={() => deletarServico(item.id)}>Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>




      <div className={styles.cadastroClienteContainer}>
        <div className={styles.usersListContainer}>
          <h1>Usuários cadastrados</h1>
          <div className={styles.usersListContainer}>
            {usersList.length === 0 ? (
              <p>Nenhum usuário encontrado.</p>
            ) : (
              <table className={styles.usersTable} style={{ width: '90%' }}>
                <tbody style={{ width: '100%' }}>
                  {usersList.map((user) => (
                    <div style={{ width: '100%', padding: '10px', backgroundColor: "#e0e0e0", borderRadius: '5px', marginBottom: '10px' }}>
                      <div >
                        {user.login}
                      </div>
                    </div>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>







      <div className={styles.cadastroClienteContainer}>
        <div className={styles.usersListContainer}>
          <h1>Vendas lançadas</h1>
          <div className={styles.usersListContainer}>
            <tbody style={{ width: '100%' }}>
              {vendaList.length === 0 ? (
                <p>Nenhuma venda encontrada.</p>
              ) : (
                <div
                  className={styles.cadastroItems06}
                  style={{
                    // padding: "20px",
                    borderRadius: "20px",
                    backgroundColor: "white",
                    // margin: "40px",
                    overflow: "visible",
                    maxWidth: "600px",
                    paddingTop: "40px",
                  }}
                >
                  <GraficoVenda rawData={vendaList} />
                  {/* Select para escolher o intervalo de dias */}
                  <div style={{ marginBottom: "20px" }}>
                    <label style={{ fontWeight: "bold", marginRight: "10px" }}>Selecionar período:</label>
                    <select
                      value={rangeDateSells}
                      onChange={(e) => setRangeDateSells(parseInt(e.target.value))}
                      style={{ padding: "5px", borderRadius: "5px", fontSize: "16px" }}
                    >
                      {/* <option value={1}>Último 1 dia</option> */}
                      <option value={7}>Últimos 7 dias</option>
                      <option value={30}>Últimos 30 dias</option>
                      <option value={60}>Últimos 60 dias</option>
                      <option value={180}>Últimos 180 dias</option>
                    </select>
                  </div>
                </div>
              )}
            </tbody>
          </div>
        </div>
      </div>



    </div>
  );
}

export default Adm;